import { Divider, Grid, Typography, TypographyProps } from "@mui/material";

type FormSectionHeadingProps = {
  title: string;
  showDivider?: boolean;
  variant?: TypographyProps["variant"];
  fontSize?: number;
  mt?: number;
  mb?: number;
};

export const FormSectionHeading = ({
  title,
  showDivider = true,
  variant = "h5",
  fontSize,
  mt = 3,
  mb,
}: FormSectionHeadingProps) => {
  return (
    <Grid item xs={12} mt={mt} mb={mb}>
      {showDivider && <Divider />}
      <Typography
        variant={variant}
        fontSize={fontSize}
        sx={{ mt: showDivider ? 5 : 0 }}>
        {title}
      </Typography>
    </Grid>
  );
};
